export const fileSizeUnits = ["B", "KB", "MB", "GB", "TB"];
